var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2693 14.6326C17.8212 15.5506 17.876 16.7002 18.6087 17.4634L22.8385 21.8694C23.3326 22.3841 23.3326 23.197 22.8385 23.7117C22.315 24.257 21.4429 24.257 20.9194 23.7117L16.8721 19.4957C16.0927 18.6839 14.8573 18.6269 13.8917 19.117C12.6384 19.7531 11.2348 20.1126 9.74998 20.1126C4.4921 20.1126 0.2 15.6536 0.2 10.1563C0.2 4.65898 4.49205 0.2 9.74993 0.2C15.0078 0.2 19.2999 4.65899 19.2999 10.1563C19.2999 11.7677 18.9263 13.2868 18.2693 14.6326ZM2.80001 10.1563C2.80001 14.1362 5.90974 17.3875 9.74998 17.3875C13.5902 17.3875 16.6999 14.1362 16.6999 10.1563C16.6999 6.17633 13.5902 2.92503 9.74998 2.92503C5.90974 2.92503 2.80001 6.17633 2.80001 10.1563Z",
    fill: "#412A7C",
    stroke: "#412A7C",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.fbd7549826625a996018706668b70ee2.svg";
export { ForwardRef as ReactComponent };